import { Grid } from '@mui/material';
import ProductCard from './ProductCard/ProductCard';
import { useAppUI } from 'context/AppUIProvider/useAppUI';
import { Product } from 'src/types/common';
import { ScrollXItem, ScrollXWrapper } from 'src/components/styles';
import { ProductCardProps } from 'src/features/products/presentation/components/ProductCard/ProductCard.types';

type ProductListProps = {
  products: Product[];
  variant?: 'grid' | 'scrollX';
  productCardProps?: Partial<ProductCardProps>;
  limit?: number;
};

const ProductList = ({
  products,
  variant = 'grid',
  productCardProps,
  limit,
}: ProductListProps) => {
  const { isMobile } = useAppUI();

  const producstToShow = limit ? products?.slice(0, limit) : products;

  if (variant === 'scrollX' && isMobile) {
    return (
      <ScrollXWrapper px={1}>
        {producstToShow?.map((item, i) => (
          <ScrollXItem
            width={{ md: '15%', sm: '25%', xs: '33%' }}
            key={`${item.product.pk}-productList-${i}`}
          >
            <ProductCard product={item} {...productCardProps} />
          </ScrollXItem>
        ))}
      </ScrollXWrapper>
    );
  }

  return (
    <Grid container rowSpacing={2} columnSpacing={{ md: 1, sm: 1, xs: 0.5 }}>
      {producstToShow?.map((item, i) => (
        <Grid
          item
          xs={4}
          sm={3}
          md={2.4}
          key={`${item.product.pk}-productList-${i}`}
        >
          <ProductCard product={item} {...productCardProps} />
        </Grid>
      ))}
    </Grid>
  );
};

export default ProductList;
